/// <reference path="../../types.d.ts" />

export const STORAGE_KEY_MASTER = "nh_family_master_key_v1";
export const STORAGE_KEY_SESSION_TOKEN = "nh_family_session_token_v1";
export const STORAGE_KEY_SESSION_ROLE = "nh_family_session_role_v1";
export const STORAGE_KEY_EDITOR_NAME = "nh_family_editor_name_v1";
export const STORAGE_KEY_LANG = "nh_family_lang";
export const STORAGE_KEY_THEME = "nh_family_theme";
export const STORAGE_KEY_TREE_ANCESTOR_DEPTH = "nh_family_tree_anc_depth_v1";
export const STORAGE_KEY_TREE_DESCENDANT_DEPTH = "nh_family_tree_desc_depth_v1";
export const STORAGE_KEY_TREE_SHOW_SIBLINGS = "nh_family_tree_show_siblings_v1";
export const STORAGE_KEY_TREE_SHOW_SPOUSES = "nh_family_tree_show_spouses_v1";

export const ADMIN_CODES = new Set([
  "adminniksic",
  "niksicadmin",
  "adminhocic",
  "hocicadmin",
]);

export const EDITOR_CODES = new Set([
  "niksicedit",
  "hocicedit",
  "niksic2026",
]);

export const FEATURED_BRANCHES = [
  { id: "I227", labelTr: "Holoviç Molla Ahmet (Kök)", labelEn: "Holoviç Molla Ahmet (Root)" },
  { id: "I711", labelTr: "Zehra Ceriç & Süleyman", labelEn: "Zehra Ceriç & Süleyman" },
  { id: "I226", labelTr: "Muhammet (Mehmet) Hoca", labelEn: "Muhammet (Mehmet) Hoca" },
  { id: "I14", labelTr: "Adem & Cevahir", labelEn: "Adem & Cevahir" },
  { id: "I76", labelTr: "Fatma & İbrahim Güvenal", labelEn: "Fatma & İbrahim Güvenal" },
  { id: "I8", labelTr: "Naşit Hasan & Ülfet Ener", labelEn: "Naşit Hasan & Ülfet Ener" },
  { id: "I585", labelTr: "Ömer & Cemile Müsiç", labelEn: "Ömer & Cemile Müsiç" },
  { id: "I462", labelTr: "Süleyman Özbek Kolu", labelEn: "Süleyman Özbek Branch" },
  { id: "I127", labelTr: "İbrahim Mekik Kolu", labelEn: "İbrahim Mekik Branch" },
  { id: "I273", labelTr: "Fatma Alime Cidiç", labelEn: "Fatma Alime Cidiç" },
  { id: "I0", labelTr: "Çağlar Ener", labelEn: "Çağlar Ener" },
  { id: "I20", labelTr: "Emrecan Ener", labelEn: "Emrecan Ener" },
];

export const NODE_W = 196;
export const SPOUSE_W = 184;
export const COLLATERAL_W = 184;
export const SPOUSE_GAP = 30;
export const SIBLING_GAP = 20;
export const SUBTREE_GAP = 46;
export const LEVEL_H = 154;

